// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__mVIYM"};